// Copyright (c) 2016 Deere & Company

import RgaAdditionalDataInfo, {getDefaultState as getRgaAdditionalDataInfo} from '../state/rga-additional-data-info';
import actions from '../../actions-list';

const setRgaAdditionalDataInfo = (state, action) =>
    RgaAdditionalDataInfo.update(state, {
        $set: action.additionalDataInfo
    });

const setRgaAdditionalTestSelectedDomain = (state, action) =>
        RgaAdditionalDataInfo.update(state, {
            $set: {
                dataParameters: state.dataParameters.map(param =>
                    param.dataTypeId.includes('ZTEST') ?
                        {...param, paramValue: action.testDataSelectedDropDown.value} :
                        param
                ),
                dataType: state.dataType,
                responsibleUnit: state.responsibleUnit,
                rgaNumber: state.rgaNumber,
                testData: action.testDataSelectedDropDown
            }
        });

const setRgaAdditionalComments = (state, action) => {

    const index = state.dataParameters.findIndex(dataObj =>
    dataObj.dataParamId === action.item.dataParamId
);

    if (index === -1) {

        return state;

    }
    return RgaAdditionalDataInfo.update(state, {
        dataParameters: {
            [index]: {
                $merge: {
                    [action.field]: action.value
                }
            }
        }
    });

};

export default (state = getRgaAdditionalDataInfo(), action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_ADDITIONAL_DATA_INFO]: setRgaAdditionalDataInfo,
        [actions.UPDATE_RGA_ADDITIONAL_DATA_TEST_SELECTED_DOMAIN]: setRgaAdditionalTestSelectedDomain,
        [actions.UPDATE_RGA_ADDITIONAL_DATA_COMMENTS]: setRgaAdditionalComments
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/additional-data-info.js